module.exports = __webpack_public_path__ + "img/Dr_Ishwar_Bharadwaj.375029f9.jpg";